import { PageLinks } from '../constants';
import { getDirtySearchObject } from '../store/slices/tripSearch';
import encodeSearchObjToQueryString from './encodeSearchObjToQueryString';
import getBaseQueryFromRouterQuery from './getBaseQueryFromRouterQuery';

const setURLParams = ({ searchObj, searchedMode, router, isDedicatedHotelPage }) => {
  const currentFilterObject = getDirtySearchObject({ searchObj, searchedMode });
  const baseQueryObject = router ? getBaseQueryFromRouterQuery(router.query, searchedMode) : {};

  const nextQueryObject = {
    ...baseQueryObject,
    ...currentFilterObject,
    searchMode: searchedMode,
  };

  if (Object.keys(nextQueryObject).length) {
    const resEncodeURL = encodeSearchObjToQueryString(
      nextQueryObject,
      searchedMode,
      isDedicatedHotelPage,
    );
    if (router) {
      if (isDedicatedHotelPage) {
        router.replace(`${window.location.pathname}?${resEncodeURL}`);
      } else router.replace(`/?${resEncodeURL}`);
    } else return resEncodeURL;
  } else if (router) {
    router.replace(PageLinks.Home.url);
  }
  return undefined;
};

export default setURLParams;
